import React from "react";
import Partnership from "./Partnership/Partnership";
import Query from "./Query/Query";
import Volunteering from "./Volunteering/Volunteering";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";

const Opportunities = () => (
  <PageLayout>
    <PageHero
      title="Kindness Opportunities"
      subtitle="Volunteering, partnerships — find your path to make a difference."
      light
    />
    <Volunteering />
    <Partnership />
    <Query />
  </PageLayout>
);

export default Opportunities;
